function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TouchableOpacity } from "react-native";
import { parseGQLDateTime } from "@oui/lib/src/gqlDate";
import { Button } from "./Button";
import { Text } from "./Text";
import { View } from "./View";
import { useI18n } from "../lib/i18n";
import { useTheme } from "../styles";
/**
 * Clickable item that can perform an action when pressed.&#x20;
 *
 * Props:
 *
 * ```
 *   text: string;
 *   description?: string;
 *   completedAt?: string;
 *   onPress: () => void;
 *   buttonProps?: Partial<ComponentProps<typeof Button>>;
 *   testID?: string;
 * ```
 *
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̅̃̀̀̆̉̀̀̆̎̀̀̆̇̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̆̌̀̀̆́̀̀̇̉̀̀̆̏̀̀̇̅̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆́̀̀̆̌̀̀̆̉̀̀̆̇̀̀̆̎̀̀̂̍̀̀̇̃̀̀̇̄̀̀̆́̀̀̇̂̀̀̇̄̀̀̂̂̀̀̇̍̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̎̀̀̇̄̀̀̆̅̀̀̆̎̀̀̇̄̀̀̂̂̀̀̃̊̀̀̅̋̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̃̅̀̀̃́̀̀̆̄̀̀̃̃̀̀̃̉̀̀̆̃̀̀̆̄̀̀̃̈̀̀̂̍̀̀̆̃̀̀̃̇̀̀̃̆̀̀̃̀̀̀̂̍̀̀̃̄̀̀̃̃̀̀̆̂̀̀̃̅̀̀̂̍̀̀̆̂̀̀̃̆̀̀̃̉̀̀̆̃̀̀̂̍̀̀̃̄̀̀̃̆̀̀̃̄̀̀̃̈̀̀̃̅̀̀̃̀̀̀̃̉̀̀̃̄̀̀̃̀̀̀̃̂̀̀̃̃̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̆̌̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̉̀̀̆̍̀̀̆́̀̀̆̇̀̀̆̅̀̀̂̍̀̀̃̂̀̀̃̀̀̀̃̂̀̀̃̄̀̀̃́̀̀̃̂̀̀̃̀̀̀̃̃̀̀̂̍̀̀̃̀̀̀̃̂̀̀̃̀̀̀̃̀̀̀̃̃̀̀̃̉̀̀̂̎̀̀̇̀̀̀̆̎̀̀̆̇̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̈̀̀̆̅̀̀̆̉̀̀̆̇̀̀̆̈̀̀̇̄̀̀̂̂̀̀̃̊̀̀̃̆̀̀̃̂̀̀̂̌̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̄̀̀̃̈̀̀̃̇̀̀̇̍̀̀̇̍̀̀̅̍̀̀̇̍}
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-20}
 */ export function WorksheetListItem(props) {
    var theme = useTheme().theme;
    var formatDate = useI18n().formatDate;
    return /*#__PURE__*/ _jsx(TouchableOpacity, {
        onPress: props.onPress,
        style: {
            paddingVertical: 0
        },
        role: "menuitem",
        testID: props.testID,
        children: /*#__PURE__*/ _jsxs(View, {
            row: true,
            style: {
                justifyContent: 'space-between'
            },
            children: [
                /*#__PURE__*/ _jsxs(View, {
                    spacing: 4,
                    flex: 1,
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            text: props.text,
                            size: 17,
                            weight: "bold",
                            numberOfLines: 2
                        }),
                        props.description ? /*#__PURE__*/ _jsx(Text, {
                            text: props.description,
                            numberOfLines: 1,
                            color: theme.color.gray400
                        }) : null,
                        props.completedAt ? /*#__PURE__*/ _jsx(Text, {
                            text: "Completed ".concat(formatDate(parseGQLDateTime(props.completedAt), {
                                month: 'short',
                                day: '2-digit'
                            })),
                            size: 15,
                            color: theme.color.gray300
                        }) : null
                    ]
                }),
                /*#__PURE__*/ _jsx(Button, _object_spread({
                    alignSelf: "center",
                    icon: "caret-right",
                    onPress: props.onPress,
                    variant: "text",
                    "aria-label": "Go to item"
                }, props.buttonProps))
            ]
        })
    });
}
